import { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Box,
  Chip,
} from '@mui/material';
import { Link } from 'react-router-dom';
import { newsApi, News } from '../api/news';

export default function NewsPage() {
  const [news, setNews] = useState<News[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    newsApi.getAll().then((data) => {
      setNews(data);
      setLoading(false);
    });
  }, []);

  if (loading) {
    return (
      <Container sx={{ py: 4 }}>
        <Typography>Загрузка...</Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      <Typography variant="h2" gutterBottom sx={{ mb: 4 }}>
        Новости
      </Typography>

      <Grid container spacing={4}>
        {news.map((item) => (
          <Grid item xs={12} md={6} key={item._id}>
            <Card
              component={Link}
              to={`/news/${item.slug}`}
              sx={{ textDecoration: 'none', height: '100%', display: 'flex', flexDirection: 'column' }}
            >
              {item.coverImage && (
                <CardMedia
                  component="img"
                  height="240"
                  image={item.coverImage}
                  alt={item.title}
                />
              )}
              <CardContent sx={{ flexGrow: 1 }}>
                <Box sx={{ mb: 2, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                  {item.tags.map((tag) => (
                    <Chip key={tag} label={tag} size="small" />
                  ))}
                </Box>

                <Typography variant="h5" gutterBottom>
                  {item.title}
                </Typography>

                <Typography variant="body2" color="text.secondary" paragraph>
                  {item.excerpt || item.content.substring(0, 200)}...
                </Typography>

                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2 }}>
                  <Typography variant="caption" color="text.secondary">
                    {item.author.firstName} {item.author.lastName}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {new Date(item.publishedAt || item.createdAt).toLocaleDateString('ru-RU')}
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {news.length === 0 && (
        <Box sx={{ textAlign: 'center', py: 8 }}>
          <Typography variant="h6" color="text.secondary">
            Нет новостей
          </Typography>
        </Box>
      )}
    </Container>
  );
}
